/* eslint-disable react/jsx-boolean-value */
/*
 * Add Folder (modal contents) Component
 */
import {useState} from 'react';
import './AddFolder.scss';
import Locale from '../util/Locale';
import LoadingIndicator from './LoadingIndicator';

const ILLEGAL_FOLDERS = ['___ADV_VIDEO___'];

const AddFolder = ({title, setShowModal, onAction}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(true);
    const [name, setName] = useState(title);

    const isLegalFolder = myName => {
        return myName ? !ILLEGAL_FOLDERS.includes(myName) : false;
    };

    const hasName = () => {
        return name && name !== '' && name.trim() !== '';
    };

    const renderError = () => {
        return <div className="add-folder-error">{Locale.getText('ADD_FOLDER_ERROR')}</div>;
    };

    const renderFooter = () => {
        if (!status) {
            return (
                <div className="add-footer">
                    <nsemble-button key="CLOSE" text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                </div>
            );
        }
        return (
            <div className="add-footer">
                <nsemble-button key="CANCEL" text onClick={() => setShowModal && setShowModal(false)}>
                    {Locale.getText('CANCEL')}
                </nsemble-button>
                <LoadingIndicator isLoading={isLoading}>
                    <nsemble-button
                        key="ADD_FOLDER"
                        text
                        onClick={async event => {
                            const button = event.currentTarget;
                            button.disabled = true;
                            setIsLoading(true);
                            if (isLegalFolder(name)) {
                                const result = await onAction(name);
                                button.disabled = false;
                                if (result) {
                                    setShowModal(false);
                                } else {
                                    setStatus(result);
                                    setIsLoading(false);
                                }
                            }
                            setStatus(undefined);
                            setIsLoading(false);
                        }}
                        disabled={!hasName() ? true : undefined}
                    >
                        {Locale.getText('ADD_FOLDER')}
                    </nsemble-button>
                </LoadingIndicator>
            </div>
        );
    };

    const renderContents = () => {
        return (
            <div>
                <div id="modal-header">
                    <h1>{name}</h1>
                </div>
                <div id="modal-body">
                    <div className="add-folder">
                        <div className="add-section">
                            <span className="add-title">{Locale.getText('FOLDER_NAME')}</span>
                            <nsemble-input
                                autofocus={true}
                                value={name || ''}
                                name="label"
                                onInput={event => {
                                    setName(event.target.value);
                                }}
                                error={!hasName() ? Locale.getText('ADD_FOLDER_NOT_EMPTY') : undefined}
                            />
                        </div>
                        {!status && renderError()}
                    </div>
                </div>
                <div id="modal-footer">{renderFooter()}</div>
            </div>
        );
    };

    return renderContents();
};

export default AddFolder;
